export type MetaCardVariant = "plain" | "highlighted";

type VariantType = {
    variantHeader: string;
    variantContainer: string;
    variantContainerWithValue: string | null;
    variantIcon: string | null;
    variantText: string | null;
};

const variantStyles: Record<MetaCardVariant, VariantType> = {
    plain: {
        variantContainer: "scenario-meta-card border rounded-3 d-flex flex-column w-100 justify-content-between",
        variantContainerWithValue: null,
        variantHeader: "flex-row",
        variantIcon: null,
        variantText: "fw-semibold"
    },
    highlighted: {
        variantContainer: "border rounded-3 p-3 d-flex flex-column align-items-start w-100 justify-content-between gap-1 bg-white",
        variantContainerWithValue: "!k-border-brand-ai-surface-light rounded-3 p-3 d-flex flex-column align-items-start w-100 justify-content-between gap-1 bg-white",
        variantHeader: "flex-column ",
        variantIcon: "k-text-primary",
        variantText: "fs-8 fw-medium"
    }
};

type MetaCardProps = {
    icon: React.ReactNode;
    label: string;
    value?: string;
    placeholder?: string;
    wide?: boolean;
    variant?: MetaCardVariant;
};

const MetaCard = ({ icon, label, value, placeholder, variant = "plain" }: MetaCardProps) => {
    const hasValue = Boolean(value?.trim());
    const displayValue = hasValue ? value : placeholder ?? "";
    const { variantHeader: variantClassName, variantContainer, variantContainerWithValue, variantIcon, variantText } = variantStyles[variant];

    return (
        <div className={`${(hasValue && variantContainerWithValue) || variantContainer}`}>
            <div className={`d-flex ${variantClassName} gap-1 ${hasValue ? "text-secondary" : "text-secondary opacity-75"}`}>
                <span className={`d-inline-flex flex-shrink-0 ${hasValue && variantIcon}`}>{icon}</span>
                <span className={`scenario-meta-label text-uppercase ${variantText}`}>
                    {label}
                </span>
            </div>
            <span className={`scenario-meta-value text-truncate ${hasValue ? "fw-semibold text-body" : "fw-normal text-secondary opacity-50"}`}>
                {displayValue}
            </span>
        </div>
    );
};

export default MetaCard;
